import { create } from "zustand";
import { NotificationInterface, notificationSlice } from "./notification";

export const useNotificationStore = create<NotificationInterface>()((...a) => ({
  ...notificationSlice(...a),
}));
